const ACCOUNT_TYPE: Record<string, string> = {
  'Cuenta corriente': 'CAT_CSH_CCTE',
  'Cuenta vista': 'CAT_CSH_CVIS',
  'Cuenta ahorro': 'CAT_CSH_CAHO',
};

export const handleExportItauTxt = async (
  payments: any,
  id: any,
  message?: string,
) => {
  console.log(payments);

  const filename = `Itau_${id}_${new Date().toDateString()}.txt`;

  const m = message || `OPERACION ${id}`;

  const payment = payments[0];

  const { totalAmount, numberOfPayments } = payments.reduce(
    (acc: { numberOfPayments: number; totalAmount: number }, payment: any) => {
      acc.numberOfPayments += 1;
      acc.totalAmount += payment.amount;
      return acc;
    },
    { numberOfPayments: 0, totalAmount: 0 },
  );

  const identifier =
    payment.businessOriginIdentifier ||
    payment.bankAccountOrigin?.holderIdentifier;

  const headers = {
    identifier: identifier.replace('-', ''),
    numberOfPayments: numberOfPayments,
    totalAmount: totalAmount,
    serviceType: '007001',
    backupType: 'CAT_CSH_CONTRACT_ACCOUNT',
    accountNumber: payment.bankAccountOriginNumber,
    description: 'NOMINA ' + m,
    originStatementNote: m,
    destinationStatementNote: m,
  };

  let parsedData = Object.values(headers).join(',') + '\n';

  const registries = payments.map((p: any) => {
    return {
      identifier: p.bankAccountDestinationHolderIdentifier.replace('-', ''),
      name: p.bankAccountDestinationHolderName,
      email: p.bankAccountDestinationHolderEmail || '',
      paymentType: 'CAT_CSH_TRANSFER',
      bankCode: p.bankAccountDestinationBankCode,
      accountType: ACCOUNT_TYPE[p.bankAccountDestinationAccountType],
      accountNumber: p.bankAccountDestinationNumber,
      paymentDate: '',
      reference1: '',
      reference2: '',
      amount: p.amount.toString(),
      backupType: 'CAT_CSH_CCTE',
      backupNumber: headers.accountNumber,
      officeCode: '',
      emailNote: p.bankAccountDestinationHolderEmail,
      paymentDetail: m,
      originStatementNote: m,
      destinationStatementNote: m,
    };
  });

  for (const registry of registries) {
    const row = Object.values(registry).join(',') + '\n';
    parsedData += row;
  }

  const txtContent = `data:text/plain;charset=utf-8,${parsedData}`;
  const encodedURI = encodeURI(txtContent);

  const a = document.createElement('a');
  a.href = encodedURI;
  a.download = filename;
  a.click();
};
